import request from "../utils/request";

export function getList (data) {
    return request({
        url: '/api/products/',
        method: 'get',
        data
    })
}
export function getInfo (id) {
    return request({
        url: '/api/products/' + id,
        method: 'get'
    })
}
